(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-preplace-template"]) return;
  try {
    
var elements = document.querySelectorAll('[data-swiper]');

elements.forEach((el)=>{
    if(el.offsetWidth > 0){
        doSlider(el);
    } else {
        //elementos com data-wait
        let listen = document.querySelectorAll('[data-wait="slider"]');
        console.log("initSliders -> listen", listen)
        listen.forEach(item => {
            item.addEventListener('click',() => {
                setTimeout(() => {
                    doSlider(el);
                }, 1000);
            })
        });
    }

});

function doSlider(el) {
    let thumbs = el.getAttribute("data-thumbs"),
        thumbsSlider = null;
    
    console.log('Before Thumbs');

    if(!!thumbs){
        thumbs = JSON.parse(thumbs);
        
        console.log("doSlider -> thumbs.wrapper", thumbs.wrapper)
        thumbsSlider = new Swiper(document.querySelector(thumbs.wrapper), thumbs.props);
        console.log("doSlider -> thumbsSlider", thumbsSlider)
    }

    var slider  = new Swiper(el, {
        autoplay: !!el.getAttribute("data-autoplay") ? { delay: el.getAttribute("data-autoplay") } : false,
        loop: Boolean(el.getAttribute("data-loop")) || false,
        freeMode: Boolean(el.getAttribute("data-free-mode")) || false,
        loopedSlides: Boolean(el.getAttribute("data-looped-slides")) || false,
        watchSlidesVisibility: Boolean(el.getAttribute("data-slides-visibility")) || false,
        watchSlidesProgress: Boolean(el.getAttribute("data-slides-progress")) || false,
        breakpoints: {
            1280: {
                centeredSlides: Boolean(el.getAttribute("data-center")) || false,
                slidesPerView: el.getAttribute("data-slides") || 1,
                spaceBetween: el.getAttribute("data-space") || 0
            },
            1024: {
                centeredSlides: Boolean(el.getAttribute("data-center-xl")) || Boolean(el.getAttribute("data-center")) || false,
                slidesPerView: el.getAttribute("data-slides-xl") || el.getAttribute("data-slides") || 1,
                spaceBetween: el.getAttribute("data-space-xl") || el.getAttribute("data-space") || 0
            },
            992: {
                centeredSlides: Boolean(el.getAttribute("data-center-lg")) || Boolean(el.getAttribute("data-center")) || false,
                slidesPerView: el.getAttribute("data-slides-lg") || el.getAttribute("data-slides") || 1,
                spaceBetween: el.getAttribute("data-space-lg") || el.getAttribute("data-space") || 0
            },
            768: {
                centeredSlides: Boolean(el.getAttribute("data-center-md")) || Boolean(el.getAttribute("data-center")) || false,
                slidesPerView: el.getAttribute("data-slides-md") || el.getAttribute("data-slides") || 1,
                spaceBetween: el.getAttribute("data-space-md") || el.getAttribute("data-space") || 0
            },
            320: {
                centeredSlides: Boolean(el.getAttribute("data-center-xs")) || Boolean(el.getAttribute("data-center")) || false,
                slidesPerView: el.getAttribute("data-slides-xs") || el.getAttribute("data-slides") || 1,
                spaceBetween: el.getAttribute("data-space-xs") || el.getAttribute("data-space") || 0
            }
        },
        navigation: {
            nextEl: el.getAttribute("data-nav-next"),
            prevEl: el.getAttribute("data-nav-prev"), 
        },
        thumbs: {
            //Fazer o JSON.stringfy para passar o swiper com as thumbs
            swiper: !!thumbsSlider ? thumbsSlider : false,
        }
    });
    console.log('slider', slider);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
$( function() {
  $( "#accordion" ).accordion({
  	heightStyle: "content",
	collapsible: false
  });
$('#accordion .ui-accordion-content').show();
$('#accordion > ul > li').addClass( 'st-open' );
$('#accordion > ul > li div.st-content').show();
} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
